import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: (theme: Theme) => theme.spacing(2),
  },
  item: {
    '&[data-disabled="true"]': {
      color: (theme: Theme) => theme.palette.text.disabled,
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: (theme: Theme) => theme.spacing(1),

    '& + &': {
      marginTop: (theme: Theme) => theme.spacing(1),
    },
  },
} satisfies Record<string, SxProps<Theme>>
